function mediaManagerToProGallery(items) {
  return items.map(function (item, index) {
    var height = item.height,
        width = item.width,
        id = item.id,
        sourceName = item.sourceName,
        title = item.title,
        description = item.description,
        fileName = item.fileName,
        uri = item.uri,
        link = item.link,
        focalPoint = item.focalPoint;
    var name = id.split('~')[0].split('_')[1];
    return {
      metadata: {
        height: height,
        lastModified: new Date().getTime(),
        name: name,
        size: height * width,
        width: width,
        sourceName: sourceName,
        title: title,
        description: description,
        fileName: fileName,
        type: 'image',
        focalPoint: focalPoint,
        uri: uri,
        link: link
      },
      orderIndex: index,
      photoId: name,
      url: id
    };
  });
}

function proGalleryToMediaManager() {}

export { mediaManagerToProGallery, proGalleryToMediaManager };